import { connect } from "react-redux";
import { useEffect } from "react";
import { stockLevelAnalysis } from "../../../redux/actions/API/dashboardActions";
import OutOfStockExtra from "./OutOfStockExtra";

interface IOutOfStockItemsProps {
  stockLevelAnalysis: Function;
  stockLevelAnalysisState: any;
  stockLevelAnalysisLoading: boolean;
  companyId: any;
}

const OutOfStockItems: React.FC<IOutOfStockItemsProps> = ({
  companyId,
  stockLevelAnalysis,
  stockLevelAnalysisState,
  stockLevelAnalysisLoading,
}) => {
  useEffect(() => {
    stockLevelAnalysis({
      companyId: Number(companyId),
      type: "outOfStock",
    });
  }, [companyId, stockLevelAnalysis]);

  return (
    <OutOfStockExtra
      loading={stockLevelAnalysisLoading}
      tableData={stockLevelAnalysisState}
    />
  );
};

const mapStateToProps = (state: any) => ({
  companyId: state.api.login?.data?.companyId,
  stockLevelAnalysisState: state.api.stockLevelAnalysis?.stockLevelAnalysis,
  stockLevelAnalysisLoading: state.api.stockLevelAnalysis?.loading,
});

const mapDispatchToProps = (dispatch: any) => ({
  stockLevelAnalysis: (payload: any) => dispatch(stockLevelAnalysis(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OutOfStockItems);
